import { render } from "./HomeWhy.vue?vue&type=template&id=bf9a634c&scoped=true"
import script from "./HomeWhy.vue?vue&type=script&lang=js"
export * from "./HomeWhy.vue?vue&type=script&lang=js"

import "./HomeWhy.vue?vue&type=style&index=0&id=bf9a634c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf9a634c"]])

export default __exports__